import { ModalDialog } from '@components'
import { MODAL_SIZE } from '@constants'
import { tr, useGlobalMaintenanceMode } from 'mmfintech-commons'

import './MaintenanceModal.scss'

function MaintenanceModal() {
  const isMaintenanceMode = useGlobalMaintenanceMode()

  return isMaintenanceMode ? (
    <ModalDialog
      content={
        <div className='maintenance-modal-wrapper'>
          <div className='heading'>{tr('FRONTEND.MAINTENANCE.HEADING', 'Maintenance')}</div>
          {tr(
            'FRONTEND.MAINTENANCE.BODY',
            'We are currently performing scheduled maintenance. Please check back shortly. We apologize for any inconvenience.'
          )}
        </div>
      }
      options={{
        closeOnClickOutside: false,
        closeOnEscape: false,
        hideCloseIcon: true,
        size: MODAL_SIZE.AUTO
      }}
      visible={true}
      onClose={() => {}}
    />
  ) : null
}

export default MaintenanceModal
